export function formatCellParamName(str: string, capitalizeWords?: string[]): string {
	const parts = str.match(/[a-z]+|[A-Z][a-z]*|\d+[gG]?/g);

	if (parts) {
		return parts
			.map((part) => {
				if (/^\d+[gG]$/.test(part)) {
					return part.toUpperCase();
				} else if (
					capitalizeWords &&
					capitalizeWords.some((word) => part.toLowerCase() === word.toLowerCase())
				) {
					return part.toUpperCase();
				}

				return part.charAt(0).toUpperCase() + part.slice(1);
			})
			.join(' ');
	}

	return str;
}
